export default "__VITE_ASSET__CVa92lXr__"